import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-consignment-ol',
  templateUrl: './consignment-ol.component.html',
  styleUrls: ['./consignment-ol.component.css']
})
export class ConsignmentOlComponent implements OnInit {
    consignmentOlKeyno;

    public menu?: Menu;

    public orderNumberButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'orderhead', gotoParms: () => this.menu!.order_internal_no ?? '' }];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.consignmentOlKeyno = this.stateService.getStateParams()['consignmentol_keyno'];
    }

    private async loadMenu() {
        if (!!this.consignmentOlKeyno) {
            this.menu = (await this.datatask.Post(328, { consignmentol_keyno: this.consignmentOlKeyno }))[0];
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    consignmentol_keyno: string;
    prodname_long: string;
    quantity_ordered: string;
    quantity_todeliver: string;
    quantity_delivered: string;
    unit_no: string;
    unit_name: string;
    order_order_no: string;
    order_internal_no: string;
}
